module.exports = __webpack_public_path__ + "static/media/tip-6.b6a69258.svg";